import * as React from 'react';

export const IconFacebook = (props: React.HTMLAttributes<SVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <rect fill="currentColor" width="32" height="32" rx="16" ry="16"></rect>
    {/* tslint:disable-next-line:max-line-length */}
    <path fill="#ffffff" d="M13 13.3h1.34V12a3.5 3.5 0 0 1 .43-2 2.39 2.39 0 0 1 2.09-1 8.5 8.5 0 0 1 2.41.24l-.34 2a4.54 4.54 0 0 0-1.08-.16.81.81 0 0 0-1 .71v1.51H19l-.15 1.94h-2V22h-2.51v-6.76H13V13.3z"></path>
  </svg>
);
